/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface AsatConnectorResultDto
 */
export interface AsatConnectorResultDto {
    /**
     * Charger UniqueId (from CoreConfig).
     * @type {string}
     * @memberof AsatConnectorResultDto
     */
    chargerUniqueId?: string;
    /**
     * 1-based connector number within the charger.
     * @type {number}
     * @memberof AsatConnectorResultDto
     */
    connectorNumber?: number;
    /**
     * Power meter above the connector this result tests the linkage to.
     * @type {string}
     * @memberof AsatConnectorResultDto
     */
    powerMeterUniqueId?: string;
    /**
     * Connector↔meter linkage test status.
     * @type {string}
     * @memberof AsatConnectorResultDto
     */
    status?: AsatConnectorResultDtoStatusEnum;
    /**
     * Number of evaluation attempts made.
     * @type {number}
     * @memberof AsatConnectorResultDto
     */
    attemptCount?: number;
    /**
     * Failure code when status is Failed; otherwise null.
     * @type {string}
     * @memberof AsatConnectorResultDto
     */
    failureCode?: AsatConnectorResultDtoFailureCodeEnum;
    /**
     * Human-readable detail about the result; null when cleared on run start/reset.
     * @type {string}
     * @memberof AsatConnectorResultDto
     */
    detail?: string;
    /**
     * When the latest attempt started (UTC).
     * @type {Date}
     * @memberof AsatConnectorResultDto
     */
    lastAttemptStartedAtUtc?: Date;
    /**
     * When the latest attempt completed (UTC).
     * @type {Date}
     * @memberof AsatConnectorResultDto
     */
    lastAttemptCompletedAtUtc?: Date;
}

/**
 * @export
 */
export const AsatConnectorResultDtoStatusEnum = {
    Unknown: "Unknown",
    Pending: "Pending",
    InProgress: "InProgress",
    Passed: "Passed",
    Failed: "Failed",
    Inconclusive: "Inconclusive",
} as const;
export type AsatConnectorResultDtoStatusEnum =
    (typeof AsatConnectorResultDtoStatusEnum)[keyof typeof AsatConnectorResultDtoStatusEnum];

/**
 * @export
 */
export const AsatConnectorResultDtoFailureCodeEnum = {
    Unknown: "Unknown",
    NoDrop: "NoDrop",
    DropMismatch: "DropMismatch",
} as const;
export type AsatConnectorResultDtoFailureCodeEnum =
    (typeof AsatConnectorResultDtoFailureCodeEnum)[keyof typeof AsatConnectorResultDtoFailureCodeEnum];

/**
 * Check if a given object implements the AsatConnectorResultDto interface.
 */
export function instanceOfAsatConnectorResultDto(
    value: object,
): value is AsatConnectorResultDto {
    return true;
}

export function AsatConnectorResultDtoFromJSON(
    json: any,
): AsatConnectorResultDto {
    return AsatConnectorResultDtoFromJSONTyped(json, false);
}

export function AsatConnectorResultDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): AsatConnectorResultDto {
    if (json == null) {
        return json;
    }
    return {
        chargerUniqueId:
            json["chargerUniqueId"] == null
                ? undefined
                : json["chargerUniqueId"],
        connectorNumber:
            json["connectorNumber"] == null
                ? undefined
                : json["connectorNumber"],
        powerMeterUniqueId:
            json["powerMeterUniqueId"] == null
                ? undefined
                : json["powerMeterUniqueId"],
        status: json["status"] == null ? undefined : json["status"],
        attemptCount:
            json["attemptCount"] == null ? undefined : json["attemptCount"],
        failureCode:
            json["failureCode"] == null ? undefined : json["failureCode"],
        detail: json["detail"] == null ? undefined : json["detail"],
        lastAttemptStartedAtUtc:
            json["lastAttemptStartedAtUtc"] == null
                ? undefined
                : new Date(json["lastAttemptStartedAtUtc"]),
        lastAttemptCompletedAtUtc:
            json["lastAttemptCompletedAtUtc"] == null
                ? undefined
                : new Date(json["lastAttemptCompletedAtUtc"]),
    };
}

export function AsatConnectorResultDtoToJSON(
    value?: AsatConnectorResultDto | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        chargerUniqueId: value["chargerUniqueId"],
        connectorNumber: value["connectorNumber"],
        powerMeterUniqueId: value["powerMeterUniqueId"],
        status: value["status"],
        attemptCount: value["attemptCount"],
        failureCode: value["failureCode"],
        detail: value["detail"],
        lastAttemptStartedAtUtc:
            value["lastAttemptStartedAtUtc"] == null
                ? undefined
                : value["lastAttemptStartedAtUtc"].toISOString(),
        lastAttemptCompletedAtUtc:
            value["lastAttemptCompletedAtUtc"] == null
                ? undefined
                : value["lastAttemptCompletedAtUtc"].toISOString(),
    };
}
